import styled from 'styled-components';

export const StyledCard = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	border: 1px solid ${({ theme }) => theme.v2.color.neutral[300]};
	border-radius: 0 0 0.25rem 0.25rem;
	overflow: hidden;
	margin-top: 1rem;
	max-width: 70%;
`;

export const KycSection = styled.div<{
	$noPadding?: boolean;
	$noMaxWidth?: boolean;
	$noGap?: boolean;
}>`
	display: flex;
	flex-direction: column;
	gap: ${({ $noGap }) => ($noGap ? '0' : '1rem')};
	padding: ${({ $noPadding }) => ($noPadding ? '0' : '1rem')};
	max-width: ${({ $noMaxWidth }) => ($noMaxWidth ? 'none' : '70%')};
`;

export const SwitchWrapper = styled.div`
	flex-shrink: 0;
	display: flex;
	align-items: center;
`;

export const ItemContainer = styled.div<{ $showBorder?: boolean }>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: white;
	gap: 1rem;

	${({ $showBorder = true, theme }) =>
		$showBorder &&
		`
        border-bottom: 1px solid ${theme.v2.color.neutral[300]};
        padding-bottom: 1rem;
    `}
`;

export const TextContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	flex: 1;
	overflow: hidden;
`;

export const Title = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.v2.color.neutral[900]};
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const Description = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${({ theme }) => theme.v2.color.neutral[600]};
	line-height: 1.5;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const SectionDivider = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.v2.color.neutral[300]};
`;

export const SectionTitle = styled.div`
	color: ${({ theme }) => theme.v2.color.neutral[700]};
	font-size: 12px;
	font-weight: 600;
`;

export const KycSettingsContainer = styled.div`
	padding: 1rem;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const NestedRequirement = styled.div`
	padding-left: 1.5rem;
	border-left: 2px solid ${({ theme }) => theme.v2.color.neutral[300]};
`;
